module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "data-testid": "planningAbsence-addAbsenceModal",
      "id": "modalAjouterAbsence"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "726px",
      "min-width": "726px"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title ellipsis"
  }, [_vm._v("\n                    " + _vm._s(!_vm.idConge ? 'Création ' : 'Modification ') + " D'UNE DEMANDE D'ABSENCE " + _vm._s(_vm.titreAbsence) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "min-width": "24px",
      "type": "button",
      "title": "Fermer"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row-custom row-head mb-3 tw-items-center"
  }, [_c('div', {
    staticClass: "col-custom col-left"
  }, [_vm._v("\n                            " + _vm._s(_vm.monthNames[_vm.currentMonth]) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-relative col-custom col-center"
  }, [_c('div', {
    staticClass: "current-year",
    on: {
      "click": _vm.showDateSelector
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" "), _c('span', {
    staticClass: "tw-text-sm tw-ml-[10px] icon-inner fas fa-angle-down tw-transition-all",
    class: _vm.isDatePickerVisible ? 'tw-rotate-180' : 'tw-rotate-0'
  })]), _vm._v(" "), (_vm.isDatePickerVisible) ? _c('date-picker-modal', {
    attrs: {
      "isYear": true,
      "currentYear": _vm.currentYear
    },
    on: {
      "selectedYear": _vm.selectedYear,
      "closeModal": _vm.closeDatePicker
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-custom col-right"
  }, [_vm._v("\n                            " + _vm._s(_vm.monthNames[_vm.nextMonthMonth]) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-custom row-calendar"
  }, [_c('div', {
    staticClass: "col-custom col-left-out"
  }, [_c('button', {
    staticClass: "custom-btn btn-left",
    attrs: {
      "type": "button",
      "title": "Mois précedent"
    },
    on: {
      "click": _vm.removeMonth
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-custom col-left"
  }, [_c('div', {
    staticClass: "calendar"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isLoading) ? _c('div', _vm._l((_vm.ligneNumber), function(m) {
    return _c('div', {
      staticClass: "calendar-line"
    }, _vm._l((_vm.rowNumber), function(n) {
      return _c('div', {
        staticClass: "calendar-row tw-flex tw-items-center",
        on: {
          "click": function($event) {
            _vm.onDateClicked(m, n, false)
          }
        }
      }, [(_vm.getDayVisibleCurrentMonth(m, n, false)) ? _c('div', {
        staticClass: "box",
        class: _vm.getClasseHover(m, n, false)
      }, [_c('div', {
        staticClass: "tw-flex tw-justify-center"
      }, [_c('div', {
        staticClass: "cell cell-exist",
        class: _vm.getClasseCongesPosee(m, n, false)
      }, [_c('div', {
        staticClass: "wrap",
        style: (_vm.getStyle(m, n, false, false))
      }, [_c('div', {
        staticClass: "demi demi-left",
        style: (_vm.getStyleRightOrLeft(m, n, false, false, true))
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-annuler icon fa-duotone fa-circle-minus",
        style: (_vm.getAnnulationStyle(m, n, false, false, true))
      }), _vm._v(" "), _c('div', {
        staticClass: "demi demi-right",
        style: (_vm.getStyleRightOrLeft(m, n, false, false, false))
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-annuler icon fa-duotone fa-circle-minus",
        style: (_vm.getAnnulationStyle(m, n, false, false, false))
      }), _vm._v(" "), _c('div', {
        staticClass: "stripe"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "cell cell-select",
        class: _vm.getClasseSelection(m, n, false)
      }, [_c('div', {
        staticClass: "wrap",
        style: (_vm.getStyle(m, n, false, true))
      }, [_c('div', {
        staticClass: "demi demi-left",
        style: (_vm.getStyleRightOrLeft(m, n, false, true, true))
      }), _vm._v(" "), _c('div', {
        staticClass: "demi demi-right",
        style: (_vm.getStyleRightOrLeft(m, n, false, true, false))
      })])]), _vm._v(" "), (_vm.isToday(m, n, false)) ? _c('div', {
        staticClass: "cell tw-rounded tw-h-9 tw-w-9 tw-bg-sky-600 tw-mt-0 tw-relative"
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "number",
        class: _vm.getClassColorNumber(m, n, false)
      }, [_vm._v("\n                                                        " + _vm._s(_vm.getCalendarDayValueCurrentMonth(m, n)) + "\n                                                    ")])])]) : _vm._e()])
    }))
  })) : _c('div', {
    staticClass: "loading",
    staticStyle: {
      "height": "276px",
      "position": "relative"
    }
  }, [_c('div', {
    attrs: {
      "id": "Centrerloader"
    }
  }, [_c('loader')], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "height": "100%",
      "width": "92px",
      "background-color": "#f4fafc",
      "float": "right"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-custom col-center"
  }, [_c('button', {
    staticClass: "custom-btn custom-btn-reset",
    attrs: {
      "type": "button",
      "title": "Afficher le mois courant"
    },
    on: {
      "click": function($event) {
        _vm.remiseAZero()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-redo-alt"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-custom col-right"
  }, [_c('div', {
    staticClass: "calendar"
  }, [_vm._m(1), _vm._v(" "), (!_vm.isLoading) ? _c('div', _vm._l((_vm.ligneNumber), function(m) {
    return _c('div', {
      staticClass: "calendar-line"
    }, _vm._l((_vm.rowNumber), function(n) {
      return _c('div', {
        staticClass: "calendar-row tw-flex tw-items-center",
        on: {
          "click": function($event) {
            _vm.onDateClicked(m, n, true)
          }
        }
      }, [(_vm.getDayVisibleCurrentMonth(m, n, true)) ? _c('div', {
        staticClass: "box",
        class: _vm.getClasseHover(m, n, true)
      }, [_c('div', {
        staticClass: "tw-flex tw-justify-center"
      }, [_c('div', {
        staticClass: "cell cell-exist",
        class: _vm.getClasseCongesPosee(m, n, true)
      }, [_c('div', {
        staticClass: "wrap",
        style: (_vm.getStyle(m, n, true, false))
      }, [_c('div', {
        staticClass: "demi demi-left",
        style: (_vm.getStyleRightOrLeft(m, n, true, false, true))
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-annuler icon fa-duotone fa-circle-minus",
        style: (_vm.getAnnulationStyle(m, n, true, false, true))
      }), _vm._v(" "), _c('div', {
        staticClass: "demi demi-right",
        style: (_vm.getStyleRightOrLeft(m, n, true, false, false))
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-annuler icon fa-duotone fa-circle-minus",
        style: (_vm.getAnnulationStyle(m, n, true, false, false))
      }), _vm._v(" "), _c('div', {
        staticClass: "stripe"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "cell cell-select",
        class: _vm.getClasseSelection(m, n, true)
      }, [_c('div', {
        staticClass: "wrap",
        style: (_vm.getStyle(m, n, true, true))
      }, [_c('div', {
        staticClass: "demi demi-left",
        style: (_vm.getStyleRightOrLeft(m, n, true, true, true))
      }), _vm._v(" "), _c('div', {
        staticClass: "demi demi-right",
        style: (_vm.getStyleRightOrLeft(m, n, true, true, false))
      })])]), _vm._v(" "), (_vm.isToday(m, n, true)) ? _c('div', {
        staticClass: "cell tw-rounded tw-h-9 tw-w-9 tw-bg-sky-600 tw-mt-0 tw-relative"
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "number",
        class: _vm.getClassColorNumber(m, n, true)
      }, [_vm._v("\n                                                        " + _vm._s(_vm.getCalendarDayValueNextMonth(m, n)) + "\n                                                    ")])])]) : _vm._e()])
    }))
  })) : _c('div', {
    staticClass: "loading",
    staticStyle: {
      "height": "276px",
      "position": "relative"
    }
  }, [_c('div', {
    attrs: {
      "id": "Centrerloader"
    }
  }, [_c('loader')], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "height": "100%",
      "width": "92px",
      "background-color": "#f4fafc",
      "float": "right"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-custom col-right-out"
  }, [_c('button', {
    staticClass: "custom-btn btn-right",
    attrs: {
      "type": "button",
      "title": "Mois suivant"
    },
    on: {
      "click": _vm.addMonth
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row-custom row-type"
  }, [_c('div', {
    staticClass: "col-custom"
  }, [_c('div', {
    staticClass: "list-type"
  }, _vm._l((_vm.listTypeConge), function(type) {
    return _c('div', {
      staticClass: "li"
    }, [_c('span', {
      staticClass: "badge",
      style: ({
        backgroundColor: type.Couleur
      }),
      attrs: {
        "title": type.LibelleTypeAbsence
      }
    }, [_vm._v("\n                                        " + _vm._s(type.CodeTypeAbsence) + "\n                                    ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row-custom row-select mt-3 mb-2"
  }, [_c('div', {
    staticClass: "col-custom col-left"
  }, [_c('div', {
    staticClass: "inp-input",
    class: _vm.dateDebut != undefined ? 'validated' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateDebut),
      expression: "dateDebut"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "data-testid": "planningAbsence-addAbsenceModal-absenceStartDate-input",
      "placeholder": " ",
      "disabled": !_vm.enableInputDebutMatinAprem,
      "required": ""
    },
    domProps: {
      "value": (_vm.dateDebut)
    },
    on: {
      "change": _vm.dateChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateDebut = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Du")])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input icon ml-3 flex-grow-1",
    class: _vm.dateDebut != undefined ? 'validated' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debutMatinAprem),
      expression: "debutMatinAprem"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.enableSelectDebutMatinAprem,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.debutMatinAprem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.dateChanged]
    }
  }, [(_vm.enableDebutMatinApremM) ? _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("\n                                        Matin\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.enableDebutMatinApremA) ? _c('option', {
    attrs: {
      "value": "A"
    }
  }, [_vm._v("\n                                        Après-midi\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Période")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-custom col-right"
  }, [_c('div', {
    staticClass: "inp-input",
    class: _vm.dateDebut != undefined && _vm.nouvelleSaisie ? 'validated' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFin),
      expression: "dateFin"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "data-testid": "planningAbsence-addAbsenceModal-absenceEndDate-input",
      "placeholder": " ",
      "disabled": !_vm.enableInputFinMatinAprem,
      "required": ""
    },
    domProps: {
      "value": (_vm.dateFin)
    },
    on: {
      "change": _vm.verifyMatinAprem,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Au")])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input icon ml-3 flex-grow-1",
    class: _vm.dateDebut != undefined && _vm.nouvelleSaisie ? 'validated' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finMatinAprem),
      expression: "finMatinAprem"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.enableSelectFinMatinAprem,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.finMatinAprem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.verifyMatinAprem]
    }
  }, [(_vm.enableFinMatinApremM) ? _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("\n                                        Matin\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.enableFinMatinApremA) ? _c('option', {
    attrs: {
      "value": "A"
    }
  }, [_vm._v("\n                                        Après-midi\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Période")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row-control mt-3 inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeTypeAbsence),
      expression: "codeTypeAbsence"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "planningAbsence-addAbsenceModal-absenceType-select",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.codeTypeAbsence = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.modifyTypeAbsence]
    }
  }, _vm._l((_vm.listeTypeAbsences), function(typeAbsences) {
    return _c('option', {
      domProps: {
        "value": typeAbsences.Code
      }
    }, [_vm._v("\n                                " + _vm._s(typeAbsences.Libelle) + "\n                            ")])
  })), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Type d'absence")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 mb-2"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "inp-input",
    class: {
      'd-none': !_vm.isModeHeures
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreHeures),
      expression: "nombreHeures"
    }],
    staticClass: "input",
    attrs: {
      "step": "0.01",
      "min": "0.01",
      "max": "999.99",
      "type": "number",
      "disabled": _vm.isReadOnlyHeures,
      "required": _vm.isModeHeures
    },
    domProps: {
      "value": (_vm.nombreHeures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreHeures = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("\n                                    " + _vm._s(_vm.dureeLibelleHeures) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4",
    class: {
      'd-none': !_vm.isModeJours
    }
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreJours),
      expression: "nombreJours"
    }],
    staticClass: "input",
    attrs: {
      "step": "0.01",
      "min": "0",
      "max": "999.99",
      "type": "number",
      "disabled": _vm.isReadOnlyJours,
      "required": _vm.isModeJours
    },
    domProps: {
      "value": (_vm.nombreJours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreJours = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("\n                                    " + _vm._s(_vm.dureeLibelleJours) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4",
    class: {
      'd-none': !_vm.isModeMois
    }
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreMois),
      expression: "nombreMois"
    }],
    staticClass: "input",
    attrs: {
      "step": "0.01",
      "min": "0",
      "max": "999.99",
      "type": "number",
      "disabled": _vm.isReadOnlyMois,
      "required": _vm.isModeMois
    },
    domProps: {
      "value": (_vm.nombreMois)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreMois = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("\n                                    " + _vm._s(_vm.dureeLibelleMois) + "\n                                ")])])])]), _vm._v(" "), (!_vm.estModeSalarie()) ? _c('div', {
    staticClass: "row-custom mt-3"
  }, [_c('div', {
    staticClass: "inp-input",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.libelleBulletin),
      expression: "libelleBulletin"
    }],
    staticClass: "input",
    attrs: {
      "id": "inputNbJours",
      "type": "text"
    },
    domProps: {
      "value": (_vm.libelleBulletin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.libelleBulletin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Message Bulletin (CC = D. début, DF = D. Fin, QH = Nb Heure)")])])]) : _vm._e(), _vm._v(" "), (_vm.enableDateDernierJourTravaille && !_vm.estModeSalarie()) ? _c('div', {
    staticClass: "row-custom mt-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateDernierTravaille),
      expression: "dateDernierTravaille"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "data-testid": "planningAbsence-addAbsenceModal-absenceLastWorkDayDate-input",
      "placeholder": " ",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateDernierTravaille)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateDernierTravaille = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Jour précédent l'arrêt")])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input ml-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateRepriseReelle),
      expression: "dateRepriseReelle"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " "
    },
    domProps: {
      "value": (_vm.dateRepriseReelle)
    },
    on: {
      "change": _vm.repriseReelleChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateRepriseReelle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Reprise réelle")])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input icon ml-3",
    staticStyle: {
      "width": "290px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeMotifReprises),
      expression: "codeMotifReprises"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.enableMotifReprise,
      "required": _vm.enableMotifReprise
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.codeMotifReprises = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listeMotifReprises), function(motif) {
    return _c('option', {
      domProps: {
        "value": motif.Code
      }
    }, [_vm._v("\n                                    " + _vm._s(motif.Libelle) + "\n                                ")])
  })), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Motif de la reprise")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-custom mt-3 d-flex align-items-center"
  }, [(_vm.modeOuvertureAbsence != 1) ? _c('div', {
    staticClass: "tw-cursor-pointer tw-flex tw-gap-1",
    on: {
      "click": function($event) {
        _vm.toggleSubrogation()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid tw-duration-200 tw-text-3xl",
    class: _vm.subrogation ? 'fa-toggle-on tw-text-sky-500' : 'fa-toggle-off tw-text-gray-500'
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-text-lg tw-pt-0.5"
  }, [_vm._v("Subrogation")])]) : _vm._e(), _vm._v(" "), (_vm.subrogation) ? _c('div', {
    staticClass: "col-4 pr-0"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subrogationDebut),
      expression: "subrogationDebut"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "required": _vm.subrogation
    },
    domProps: {
      "value": (_vm.subrogationDebut)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subrogationDebut = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Début de la subrogation")])])]) : _vm._e(), _vm._v(" "), (_vm.subrogation) ? _c('div', {
    staticClass: "col-4 pr-0"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subrogationFin),
      expression: "subrogationFin"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "required": _vm.subrogation
    },
    domProps: {
      "value": (_vm.subrogationFin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subrogationFin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Fin de la subrogation")])])]) : _vm._e()]), _vm._v(" "), (_vm.estModeGestionaire()) ? _c('div', {
    staticClass: "row-custom mt-3 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "tw-cursor-pointer tw-flex tw-gap-1",
    on: {
      "click": function($event) {
        _vm.toggleEnvoiEMail()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid tw-duration-200 tw-text-3xl",
    class: _vm.envoyerEMailSalarie ? 'fa-toggle-on tw-text-sky-500' : 'fa-toggle-off tw-text-gray-500'
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-text-lg tw-pt-0.5"
  }, [_vm._v("Notifier le salarié par e-mail")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer mt-5 pr-0"
  }, [(_vm.hideCRPCEN) ? _c('button', {
    staticClass: "inp-button-modal btn-warning",
    attrs: {
      "disabled": _vm.enableCRPCEN === false,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.generationCRPCEN()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Générer mon attestation")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "data-testid": "planningAbsence-addAbsenceModal-validate-button",
      "disabled": _vm.isSaving
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button",
      "data-testid": "planningAbsence-addAbsenceModal-cancel-button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "header-day"
  }, [_c('li', [_vm._v("Lun")]), _vm._v(" "), _c('li', [_vm._v("Mar")]), _vm._v(" "), _c('li', [_vm._v("Mer")]), _vm._v(" "), _c('li', [_vm._v("Jeu")]), _vm._v(" "), _c('li', [_vm._v("Ven")]), _vm._v(" "), _c('li', [_vm._v("Sam")]), _vm._v(" "), _c('li', [_vm._v("Dim")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "header-day"
  }, [_c('li', [_vm._v("Lun")]), _vm._v(" "), _c('li', [_vm._v("Mar")]), _vm._v(" "), _c('li', [_vm._v("Mer")]), _vm._v(" "), _c('li', [_vm._v("Jeu")]), _vm._v(" "), _c('li', [_vm._v("Ven")]), _vm._v(" "), _c('li', [_vm._v("Sam")]), _vm._v(" "), _c('li', [_vm._v("Dim")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-cloud-download-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756e95bf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/modals/modalAjouterAbsence/modalAjouterAbsence.vue.html
// module id = G/FZ
// module chunks = 2